<template>
  <div>
    <SideBar
      v-if="
        $route.name != 'login' &&
        $route.name != 'not-found' &&
        $store.state.token_colimp != null
      "
    />
    <router-view />
  </div>
</template>

<script>
import SideBar from "./components/SideBar.vue";

export default {
  components: {
    SideBar,
  },
  created(){
    
  }
};
</script>

<style></style>
